// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalBiDiagnosisCodeRequest {
    static getAttributeTypeMap() {
        return MedicalBiDiagnosisCodeRequest.attributeTypeMap;
    }
}
MedicalBiDiagnosisCodeRequest.discriminator = undefined;
MedicalBiDiagnosisCodeRequest.additionalProperties = false;
MedicalBiDiagnosisCodeRequest.attributeTypeMap = [
    {
        "name": "code",
        "baseName": "code",
        "type": "string"
    },
    {
        "name": "unit",
        "baseName": "unit",
        "type": "string"
    },
];
//# sourceMappingURL=medicalBiDiagnosisCodeRequest.js.map